import { view, utils } from '@yola/ws-sdk';

const DEFAULT_PADDING_TOP_CUSTOM_PROPERTY = '--ws-column-default-padding-top';
const DEFAULT_PADDING_LEFT_CUSTOM_PROPERTY = '--ws-column-default-padding-left';
const DEFAULT_PADDING_BOTTOM_CUSTOM_PROPERTY = '--ws-column-default-padding-bottom';
const DEFAULT_PADDING_RIGHT_CUSTOM_PROPERTY = '--ws-column-default-padding-right';
const DEFAULT_COLUMN_GAP_CUSTOM_PROPERTY = '--ws-column-default-column-gap';
const DEFAULT_COLUMN_ROW_GAP_CUSTOM_PROPERTY = '--ws-column-default-row-gap';

const ATTRIBUTE_TO_CUSTOM_PROPERTY = {
  'padding-top': DEFAULT_PADDING_TOP_CUSTOM_PROPERTY,
  'padding-bottom': DEFAULT_PADDING_BOTTOM_CUSTOM_PROPERTY,
  'padding-left': DEFAULT_PADDING_LEFT_CUSTOM_PROPERTY,
  'padding-right': DEFAULT_PADDING_RIGHT_CUSTOM_PROPERTY,
  'column-gap': DEFAULT_COLUMN_GAP_CUSTOM_PROPERTY,
  'row-gap': DEFAULT_COLUMN_ROW_GAP_CUSTOM_PROPERTY,
};

const ATTRIBUTE_TO_FALLBACK_VALUE = {
  'padding-top': '32',
  'padding-bottom': '32',
  'padding-left': '40',
  'padding-right': '40',
  'column-gap': '30',
  'row-gap': '48',
};

const computeSpacingFallback = ({ elementId, attribute }) => {
  const element = view.accessors.getLiveElement(elementId);
  const fallbackValue = ATTRIBUTE_TO_FALLBACK_VALUE[attribute];

  if (!element) return fallbackValue;

  const defaultValue = getComputedStyle(element).getPropertyValue(
    ATTRIBUTE_TO_CUSTOM_PROPERTY[attribute]
  );

  if (!defaultValue) return fallbackValue;

  const parsedValue = `${parseFloat(defaultValue)}`;

  return utils.isNumeric(parsedValue) ? parsedValue : fallbackValue;
};

export default computeSpacingFallback;
